import 'whatwg-fetch';
import axios from 'axios';

export const appUrl = 'https://app.simplapp.io';

let apiUrl = __DEV__
  ? 'http://simpl-api.test'
  : __STAGE__
  ? 'https://api-staging.simplapp.io'
  : 'https://api.simplapp.io';

if (__DEV__) {
  apiUrl = 'https://api.simplapp.io';
}

export const simplApiUrlPure = (url = '') => {
  return `${apiUrl}/${url}`;
};

export const simplApiUrl = (url = '') => {
  return `${apiUrl}/api/${url}`;
};

export const simplFileUrl = () => {
  return `${apiUrl}/download/`;
};

export const simplImageUrl = (
  simplid,
  id,
  width = 32,
  height = 0,
  fit = '',
) => {
  if (typeof simplid !== 'undefined' && typeof id !== 'undefined') {
    let url = `${apiUrl}/image/${simplid}/${id}`;

    if (width !== 0) {
      url = `${url}?w=${width}`;
    }

    if (height !== 0) {
      url = `${url}&h=${height}`;
    }

    if (fit.length !== 0) {
      url = `${url}&fit=${fit}`;
    }

    return url;
  }
  return `${apiUrl}/image/`;
};

export const simplAvatarUrl = (type, id, width = 32, height = 0, fit = '') => {
  let url = `${apiUrl}/avatar/${type}/${id}`;

  if (width !== 0) {
    url = `${url}?w=${width}`;
  }

  if (height !== 0) {
    url = `${url}&h=${height}`;
  }

  if (fit.length !== 0) {
    url = `${url}&fit=${fit}`;
  }

  return url;
};

const request = (url, options) => {
  return fetch(url, options);
};

export const simplApi = (url: string, extra: {}) => {
  const token = localStorage.getItem('token');

  let params = {
    method: 'get',
    body: {},
  };

  if (__DEV__) {
    params.mode = 'no-cors';
  }

  if (typeof extra !== 'undefined') {
    params = Object.assign(params, extra);
  }

  const headers = new Headers();
  headers.set('Content-Type', 'application/json');
  headers.set('Authorization', `Bearer ${token}`);

  if (params.method !== 'get') {
    return request(`${simplApiUrl()}${url}`, {
      method: params.method,
      headers,
      body: JSON.stringify(params.body),
    });
  }

  return request(`${simplApiUrl()}${url}`, {
    method: params.method,
    headers,
  });
};

export const uploadFile = (files, callback, progressCallback, attachable) => {
  const token = localStorage.getItem('token');

  files.forEach(file => {
    const data = new FormData();
    data.append('file', file);

    if (
      typeof attachable !== 'undefined' &&
      typeof attachable.attachableId !== 'undefined'
    ) {
      data.append('attachableId', attachable.attachableId);
      data.append('attachableType', attachable.attachableType);
    }

    axios
      .post('file', data, {
        baseURL: simplApiUrl(),
        timeout: 30000,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          progressCallback(percentCompleted);
        },
      })
      .then(response => {
        // console.log(response);
        callback(response.data);
      })
      .catch(error => {
        // console.log(error);
      });
  });
};



// WEBPACK FOOTER //
// ./src/api/simplApi.js